import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import CircularProgress from "@mui/material/CircularProgress";

import partCodesService from "services/part-code-service";
import { useEffect, useState } from "react";

import ImageModal from "e4acomponents/ImageModal";
import { CopyableField } from "e4acomponents/CopyableField";
import formatPartCode from "helper/formatPartCode";


export default function PartCodeDetails({ id }) {

    const [partCode, setPartCode] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [openImageModal, setOpenImageModal] = useState(false);

    // Fetches the partcode and it's image
    useEffect(() => {
        (async () => {
            if (!id) return;
            setIsLoading(true);
            const response = await partCodesService.getPartById(id);
            if (response.data.attributes.has_image) {
                const image = await partCodesService.getImage(response.data.attributes.imagePath);
                setImageUrl(image);
            } else {
                setImageUrl("https://ami-spotlight.footbridge.tilkal.com/resources/images/image.jpg");
            }
            if (partCode) {
                setTimeout(() => setPartCode(response.data.attributes), 500);
            } else {
                setPartCode(response.data.attributes);
            }
        })();
    }, [id]);

    useEffect(() => {
        if (partCode) {
            setIsLoading(false);
        }
    }, [partCode]);

    return (

        <Card p={3}>

            <ImageModal
                open={openImageModal}
                onClose={() => setOpenImageModal(false)}
                mediaURL={imageUrl}
            />

            {isLoading ?
                (
                    <MDBox display="flex" justifyContent="center" alignItems="center" height="200px">
                        <CircularProgress />
                    </MDBox>
                ) : (
                    <MDBox p={3}>
                        <MDTypography variant="h4" fontWeight="bold" m={2}>
                            Selected Part Code's Details
                        </MDTypography>

                        <Grid container spacing={3}>
                            <Grid item xs={12} lg={5}>
                                <MDBox
                                    onClick={() => setOpenImageModal(true)}
                                    sx={{ cursor: "pointer", maxWidth: "30vh" }}
                                >
                                    <img src={imageUrl} width="100%" />
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} lg={7} p={2}>

                                {/* Title (Part Code Identifier) */}
                                <MDBox textAlign="center" mb={3}>
                                    <MDTypography variant="h5" fontWeight="medium">
                                        {partCode && <CopyableField text={formatPartCode(partCode)} variant="h3" fontWeight="medium" />}
                                    </MDTypography>
                                </MDBox>

                                {/* Description */}
                                <Grid container spacing={{ xs: 2, md: 4 }} mb={3}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }}>
                                            Description
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        {partCode && <CopyableField text={partCode.description} />}
                                    </Grid>
                                </Grid>
                                {/* Manufacturer */}
                                <Grid container spacing={{ xs: 2, md: 4 }} mb={3}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }} >
                                            Manufacturer
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        {partCode && <CopyableField text={partCode.manufacturer || "N/A"} />}
                                    </Grid>
                                </Grid>

                                {/* Manufacturer Part Number */}
                                <Grid container spacing={{ xs: 2, md: 4 }} mb={3}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }} >
                                            Manufacturer Part Number
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        {<CopyableField text={partCode ?
                                            (partCode.mpn ? partCode.mpn[partCode.preferred_mpn] : partCode.manufacturer_part_number) :
                                            "N/A"} />}
                                    </Grid>
                                </Grid>

                                {/* Vendor */}
                                <Grid container spacing={{ xs: 2, md: 4 }} mb={3}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }} >
                                            Vendor
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                            {partCode && <CopyableField text={partCode.vendors ? (partCode.vendors[`vendor-${partCode.preferred_vendor}`]) : "N/A"} />}
                                    </Grid>
                                </Grid>

                                {/* Vendor Part Number */}
                                <Grid container spacing={{ xs: 2, md: 4 }} mb={3}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }} >
                                            Vendor Part Number
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                            {partCode && <CopyableField text={(partCode.vendor_part_number ? (partCode.vendor_part_number) : "N/A")} />}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </MDBox>
                )}
        </Card>

    )
}